<template>
  <div class="category">
    <van-nav-bar title="全部分类" fixed />
    <!-- 搜索栏（图1样式 - 更明显） -->
    <div class="search-bar" @click="$router.push('/search')">
      <div class="search-icon-wrapper">
        <van-icon name="search" />
      </div>
      <span class="placeholder">请在此输入搜索关键词</span>
      <div class="arrow-wrapper">
        <van-icon name="arrow" />
      </div>
    </div>
    <div class="list-box" v-if="categoryData">
      <!-- 左侧一级分类 -->
      <div class="left">
        <ul>
          <li v-for="(item, index) in categoryData" :key="item.category_id">
            <a
              href="javascript:;"
              :class="{ active: index === activeIndex }"
              @click="activeIndex = index"
            >{{ item.name }}</a>
          </li>
        </ul>
      </div>
      <!-- 右侧二级分类商品 -->
      <div class="right">
        <div
          class="cate-goods"
          v-for="item in categoryChild"
          :key="item.category_id"
          @click="goSearchListpage(item.category_id)"
        >
          <img :src="item.image.external_url" alt="">
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getCategoryApi } from '@/api/category'

export default {
  name: 'Category',
  data () {
    return {
      categoryData: [],
      activeIndex: 0
    }
  },
  computed: {
    categoryChild () {
      const current = this.categoryData[this.activeIndex]
      return current ? current.children : []
    }
  },
  created () {
    this.getCategory()
  },
  methods: {
    async getCategory () {
      const { data: { list } } = await getCategoryApi()
      this.categoryData = list
    },
    goSearchListpage (categoryId) {
      this.$router.push({
        path: '/searchlist',
        query: { categoryId }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.category {
  padding-top: 100px;
  padding-bottom: 50px;
  height: 100vh;

  // 搜索栏（图1样式 - 更明显）
  .search-bar {
    position: fixed;
    top: 46px;
    left: 0;
    right: 0;
    z-index: 999;
    background: #ffffff;
    border-radius: 30px;
    padding: 10px 18px;
    display: flex;
    align-items: center;
    gap: 10px;
    border: 1px solid #e8edf4;
    margin: 10px 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    transition: all 0.2s ease;

    &:active {
      transform: scale(0.98);
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
    }

    .search-icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      
      /deep/ .van-icon-search {
        color: #ff6b35;
        font-size: 18px;
      }
    }

    .placeholder {
      flex: 1;
      color: #9aa0a8;
      font-size: 15px;
      font-weight: 400;
      letter-spacing: 0.3px;
    }

    .arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      
      /deep/ .van-icon-arrow {
        color: #c0c6ce;
        font-size: 14px;
      }
    }
  }

  .list-box {
    height: 100%;
    display: flex;
    margin-top: 10px;

    .left {
      width: 85px;
      height: 100%;
      background-color: #f3f3f3;
      overflow: auto;

      a {
        display: block;
        height: 45px;
        line-height: 45px;
        text-align: center;
        color: #444;
        font-size: 12px;

        &.active {
          color: #ff6b35;
          background-color: #fff;
        }
      }
    }

    .right {
      flex: 1;
      height: 100%;
      background-color: #ffffff;
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-start;
      align-content: flex-start;
      padding: 10px 0;
      overflow: auto;

      .cate-goods {
        width: 33.3%;
        margin-bottom: 10px;

        img {
          width: 70px;
          height: 70px;
          display: block;
          margin: 5px auto;
        }

        p {
          text-align: center;
          font-size: 12px;
        }
      }
    }
  }
}

.van-nav-bar {
  z-index: 999;
}
</style>